var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlipVertical1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1661 17.8489C22.0714 17.9331 21.9286 17.9331 21.8339 17.8489L15.4641 12.1869C15.2923 12.0341 15.4003 11.75 15.6302 11.75L28.3698 11.75C28.5997 11.75 28.7077 12.0341 28.5359 12.1869L22.1661 17.8489Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 21H11",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8339 24.1511C21.9286 24.0669 22.0714 24.0669 22.1661 24.1511L28.5359 29.8131C28.7077 29.9659 28.5997 30.25 28.3698 30.25L15.6302 30.25C15.4003 30.25 15.2923 29.9659 15.4641 29.8131L21.8339 24.1511Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipVertical1);
export default __webpack_public_path__ + "static/media/flip-vertical1.1aed8e936c2e346ddd6a4cd74ee2eaee.svg";
export { ForwardRef as ReactComponent };